module.exports = __webpack_public_path__ + "media/images/yellow_circle_outline_opacity-1634ab3d39a5941023ecda770744e170.svg";